<template>
    <div>
        <div class="mb-2 pb-3" style="margin-top: -15px;">
            <a @click="goBack()" class="ml-2" title="Zur Übersicht">
                <font-awesome-icon icon="home" class="mm-link" style="font-size: 1.5rem;"/>
            </a>
        </div>
        <ul class="nav nav-tabs">
            <li class="nav-item" v-if="!hasPacket">
                <a class="nav-link"
                   :class="{active: activeTab == 'packet_choice'}"
                   @click="moveTo('packet_choice')">
                    Paketwahl
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'improvement'}"
                   @click="moveTo('improvement')">
                    Aufwertung
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'address'}"
                   @click="moveTo('address')">
                    Adresse
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'payment', disabled: article_count == 0}"
                   @click="moveTo('payment')">
                    Bezahlung
                </a>
            </li>
        </ul>
        <div class="p-3 mt-3">
            <packet-choice-tab
                v-if="activeTab == 'packet_choice' && !hasPacket"
                @nextTab="setBookingCookie"
                @moveTo="moveTo"
                @success="tabSuccess"
                @error="tabError"/>
            <improvement-tab
                v-if="activeTab == 'improvement'"
                @nextTab="setBookingCookie"
                @moveTo="moveTo"
                @success="tabSuccess"
                @error="tabError"
                :object="{id: this.object_id}"
                :extensionsFilter="`onlyBookingAvailable`"
            />
            <address-tab
                v-if="activeTab == 'address'"
                @nextTab="setBookingCookie"
                @moveTo="moveTo"
                @success="tabSuccess"
                @error="tabError"/>
            <payment-tab
                v-if="activeTab == 'payment'"
                @nextTab="setBookingCookie"
                @moveTo="moveTo"
                @success="tabSuccess"
                @error="tabError"/>
        </div>
        <next-previous :addNoBack="noBack" :tab="activeTab" />
    </div>
</template>

<script>
    import PacketChoiceTab from '../../components/object/booking/PacketChoiceTab';
    import ImprovementTab  from '../../components/object/booking/ImprovementTab';
    import AddressTab      from '../../components/object/booking/AddressTab';
    import PaymentTab      from '../../components/object/booking/PaymentTab';
    import Booking         from '../../classes/Booking';
    import NextPrevious    from '../../components/object/NextPrevious';
    import EventBus        from '../../EventBus';

    export default {
        name: 'inserat-create',
        components: {
            PacketChoiceTab,
            ImprovementTab,
            AddressTab,
            PaymentTab,
            NextPrevious
        },
        data() {
            return {
                user: this.$store.state.user,
                hasPacket: false,
                activeTab: '',
                success: '',
                error: '',
                noBack: [],
                article_count: 0
            }
        },
        props: {
            object_id: {
                default: 0
            }
        },
        watch: {
            activeTab(val) {
                if(val == 'packet_choice' && this.hasPacket){
                    this.activeTab = 'improvement';
                }
            }
        },
        methods: {
            goBack(){
              this.$router.push({name: 'inserat-uebersicht', params: {page: 1}});
            },
            moveTo(tab){
                this.activeTab = tab;
            },
            getBookingCookie() {
                let booking = new Booking();

                if(this.$cookies.isKey('currentBooking')){
                    let jsonObject = this.$cookies.get('currentBooking');
                    booking        = Booking.getObjectFromJSON(jsonObject);
                }

                return booking;
            },
            setBookingCookie(booking) {
                if(booking.activeTab != ''){
                    this.activeTab = booking.activeTab;
                }
                booking.setObjectId(this.object_id);
                this.article_count = booking.article_count;
                this.$cookies.set('currentBooking', JSON.stringify(booking), booking.cookie_duration);
            },
            assignUser() {
                if(this.user){
                    if(this.user.user_type == 'gewerblich'){
                        this.$router.push('/');
                    }
                    if(!this.user.packet){
                        this.hasPacket = false;
                    }else {
                        this.hasPacket = true;
                    }
                    if(this.hasPacket){
                        this.noBack.push('improvement');
                    }
                    if(this.hasPacket && this.activeTab == 'packet_choice'){
                        this.activeTab = 'improvement';
                    }
                }
            },
            tabSuccess(msg) {

            },
            tabError(msg) {

            }
        },
        created() {
            document.title     = 'Buchungsstrecke';
            let booking        = this.getBookingCookie();
            this.activeTab     = booking.getActiveTab();
            this.article_count = booking.getArticleCount();

            if(this.object_id > 0){
                booking.setObjectId(this.object_id);
                this.setBookingCookie(booking);
            }

            EventBus.$on('NEXT_EMIT_TO_PARENT', () => {
                EventBus.$emit('NEXT_EMIT_TO_CHILD', this.activeTab.toUpperCase());
            });

            EventBus.$on('BACK_EMIT_TO_PARENT', () => {
                EventBus.$emit('BACK_EMIT_TO_CHILD', this.activeTab.toUpperCase());
            });

            this.assignUser();

            this.$store.watch(() => {
                return this.$store.getters.user;
            }, user => {
                this.user = user;
                this.assignUser();
            });
        },
        destroyed() {
            this.$cookies.remove('currentBooking');
        }
    }
</script>

<style scoped>

</style>
